import { useQuery } from '@apollo/client/react';
import { PassDetails } from '@drycut/booking-components';
import { GetPassPurchaseDocument } from '@drycut/graphql';
import { Loader } from '@drycut/ui-components';
import { useParams } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

export function PassDetailsByUid(): React.ReactElement {
  useDocumentTitle('DRYCUT - DRYPASS');

  const { slug, uid } = useParams() as { slug: string; uid: string };
  const { data, loading } = useQuery(GetPassPurchaseDocument, { variables: { uid } });

  if (loading) {
    return <Loader />;
  }

  return <PassDetails storeSlug={slug} passPurchase={data?.passPurchase} manual />;
}
